import { render, staticRenderFns } from "./CitationsOverviewTable.vue?vue&type=template&id=70c6b2bb&scoped=true&"
import script from "./CitationsOverviewTable.vue?vue&type=script&lang=js&"
export * from "./CitationsOverviewTable.vue?vue&type=script&lang=js&"
import style0 from "./CitationsOverviewTable.vue?vue&type=style&index=0&id=70c6b2bb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c6b2bb",
  null
  
)

export default component.exports